import React, { useState, useCallback, useEffect } from "react";
import UploadImage from "../Common/upload-image/UploadImage";
import ImageKit from "imagekit-javascript";
import { useQuery} from "@apollo/react-hooks";
import { CHECK_DEAL} from "../../query/checkDeal";
import { hasuraClient } from "../../apolloClient";

const Generalinfo = ({ setGeneralInfo, setStep, generalInfo }) => {
  const [imageLoading, setImageLoading] = useState(false);
  const [uploadedImg, setUploadedImg] = useState("");
  const [imageName, setImageName] = useState("");
  const [dealName, setDealName] = useState("");
  const [desc, setDescription] = useState("");
  const [condition, setCondition] = useState("");
  const [dealType, setDealType] = useState("discount");
  const [isNew, setIsNew] = useState(true);
  const [isEditData, setIsEditData] = useState(true);
  const [checkDeal, setCheckDeal] = useState(false);
  const [dealNameError, setDealNameError] = useState(false);
  const [initialName,setInitialName]=useState("")
  const [initialRender, setInitialRender] = useState(true);

  const { refetch } = useQuery(CHECK_DEAL, {
    variables: {
      name:dealName,
      business_profile_id: localStorage.getItem("profile_id"),
    },
    client: hasuraClient,
  });
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await refetch();
        if (data?.deals_count?.aggregate?.count === 1) {
          
          if (initialName !== dealName) {
           
            setDealNameError(true)
          }else{
            setDealNameError(false)
          }
        } else {
          
          setDealNameError(false);
        }
      } catch (error) {
        // Handle error if necessary
      }
    };
  
    fetchData(); // Call fetchData function on initial render
  
    // Add the dealName dependency to listen to changes
  }, [dealName]);
  
  useEffect(() => {
    if (generalInfo && isEditData) {
      setDealName(generalInfo.dealName);
      setDescription(generalInfo.desc);
      setCondition(generalInfo.condition);
      setDealType(generalInfo.dealType);
      setUploadedImg(generalInfo.uploadedImg);
      setIsEditData(false);
    }
  }, [generalInfo]);

  const imageKit = new ImageKit({
    publicKey: process.env.REACT_APP_PUBLIC_KEY,
    urlEndpoint: process.env.REACT_APP_URL_END_POINT,
    authenticationEndpoint: process.env.REACT_APP_AUTHENTICATION_END_POINT,
  });

  const handleImageUpload = async (imgObj) => {
    setImageLoading(true);
    await imageKit.upload(
      {
        file: imgObj,
        folder: "/dev/business",
        fileName: imgObj.name,
        tags: ["tag1"],
      },
      (err, result) => {
        if (result) {
          setUploadedImg(
            imageKit.url({
              src: result.url,
            })
          );
          setImageName(imgObj.name);
          setImageLoading(false);
        }
      }
    );
  };

  const handleNext = async () => {
   
        if(!dealNameError){
          
    if (dealName && desc && condition && dealType && uploadedImg) {
      let obj = {
        dealName: dealName,
        desc: desc,
        condition: condition,
        dealType: dealType,
        uploadedImg: uploadedImg,
        imagePath: `/dev/business_profile/${localStorage.getItem(
          "profile_id"
        )}/${imageName}`,
      };

      setGeneralInfo(obj);
      setStep(2);
    }
  }
      
      else{
        //  setIsNew(false)
        setCheckDeal(true);
       }

    
  };
  useEffect(() => {
    if (initialRender && generalInfo) {
      setInitialName(generalInfo.dealName);
      setInitialRender(false);
    }
  }, [generalInfo, initialRender]);
  useEffect(() => {
    if (!isEditData) {
      let obj = {
        dealName: dealName,
        desc: desc,
        condition: condition,
        dealType: dealType,
        uploadedImg: uploadedImg,
        imagePath: `/dev/business_profile/${localStorage.getItem(
          "profile_id"
        )}/${imageName}`,
      };

      setGeneralInfo(obj);

      setIsEditData(false);
    }
  }, [dealName, desc, condition, dealType, uploadedImg, imageName]);

  let dealTypeObj = {
    discount: "Discount",
    buy_1_get_1_free: "Buy 1 Get 1",
    freebies: "Freebies",
  };

  const onImageDrop = useCallback((acceptedFiles) => {
    handleImageUpload(acceptedFiles[0]);
  }, []);

  return (
    <div className="event-list-cover typeofevent-row">
      <div className="title">
        <h3>Deal information</h3>
        <p>Please enter in your deal’s information.</p>
      </div>
      <div className="eventinformation">
        <div className="eventinfo-left">
          <div className="form-group">
            <label>Deal Name</label>
            <input
              type="text"
              className="form-control"
              onChange={(e) => {
                
                setDealName(e.target.value); 
                setDealNameError(false)
                setCheckDeal(false)
                setIsNew(true)      
              }}
              value={dealName}
            />
            <p hidden={(dealName)} className="error-message">
              Deal Name required
            </p>
            {(dealNameError) ? <p  className="error-message">
              Deal Name Already Exist
            </p> : null}
            {/* <p  className="error-message">
              Deal Name Already Exist
            </p> */}
          </div>
          <div className="form-group">
            <label>Description</label>
            <textarea
              type="text"
              className="form-control"
              onChange={(e) => {
                setDescription(e.target.value);
              }}
              value={desc}
            />
            <p hidden={desc} className="error-message">
              Description required
            </p>
          </div>
          <div className="form-group">
            <label>Condition</label>
            <textarea
              type="text"
              className="form-control"
              onChange={(e) => {
                setCondition(e.target.value);
              }}
              value={condition}
            />
            <p hidden={condition} className="error-message">
              Condition required
            </p>
          </div>
        </div>
        <div className="eventinfo-right">
          <div className="form-group">
            <label>Type of Deal</label>
            <select
              className="form-control"
              onChange={(e) => {
                setDealType(e.target.value);
              }}
            >
              {generalInfo ? (
                <option
                  value={dealType}
                  label={dealTypeObj[dealType]}
                  selected
                />
              ) : (
                ""
              )}
              <option value="discount" label="Discount" />
              <option value="buy_1_get_1_free" label="Buy 1 Get 1" />
              <option value="freebies" label="Freebies" />
            </select>
            <p hidden={dealType} className="error-message">
              Deal Type required
            </p>
          </div>
          <div className="form-group add-image-group">
            <label>Add images</label>
            <div className="image-group">
              <UploadImage
                titleNeeded={false}
                onImageDrop={onImageDrop}
                disabled={!!uploadedImg}
                uploadedImg={uploadedImg}
                setUploadedImg={setUploadedImg}
                loading={imageLoading}
              />
            </div>
            <p hidden={uploadedImg} className="error-message">
              Image required
            </p>
          </div>
        </div>
      </div>
      <div className="event-button-row submit">
        <button
          className="next-btn submit-btn"
          onClick={() => {
            handleNext();
          }}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Generalinfo;
